import { Box, Grid } from "@mui/material";
import { Send } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import CustomTextField from "../components/CustomTextField";
import CustomButton from "../components/CustomButton";

const FormOurServices = () => {
  return (
    <Grid container sx={design.Back}>
      <Grid size={design.Grid1} />
      <Grid size={design.Grid5} alignSelf="center">
        <CustomText
          variant="subtitle1"
          color="#333333"
          text="Quieres saber más"
          sx={design.Title}
        >
          ¿Quieres saber más
          <br />
          sobre nuestros servicios?
        </CustomText>
        <CustomText
          variant="subtitle1"
          color="#333333"
          text="descrip"
          sx={design.Description}
        >
          En el Centro Médico Medam queremos estar siempre cerca de ti. Si
          tienes preguntas o necesitas orientación, no dudes en escribirnos.
          Nuestro equipo está listo para atender tus dudas con profesionalismo,
          empatía y la dedicación que mereces, porque tu tranquilidad es nuestra
          prioridad.
        </CustomText>
      </Grid>
      <Grid item size={design.Grid11} />
      <Grid item size={design.Grid11} />
      <Grid size={design.Grid5}>
        <Box style={design.Card}>
          <CustomTextField
            id="Escribe tu nombre"
            name="Escribe tu nombre"
            label="Escribe tu nombre"
            title="Nombre completo"
            colorTitle="#2349D0"
            type="text"
            grid={12}
            gridXS={12}
            variant="outlined"
          />
          <CustomTextField
            id="Escribe tu correo electrónico"
            name="Escribe tu correo electrónico"
            label="Escribe tu correo electrónico"
            title="Correo electrónico"
            colorTitle="#2349D0"
            type="text"
            grid={12}
            gridXS={12}
            variant="outlined"
          />
          <CustomTextField
            id="Escribe tu mensaje"
            name="Escribe tu mensaje"
            label="Escribe tu mensaje"
            title="Mensaje"
            colorTitle="#2349D0"
            type="text"
            grid={12}
            gridXS={12}
            rows={2}
            variant="outlined"
          />
          <CustomButton
            type="submit"
            variant="contained"
            color="success"
            colorTexto="#FFF"
            backgroundColor="#489E4D"
            width="98%"
            height={50}
            grid={12}
            gridXS={12}
            borderRadius={10}
            style={design.Buttom}
          >
            Enviar mensaje <Send style={design.Icon} />
          </CustomButton>
        </Box>
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};
export default FormOurServices;

const design = {
  Back: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 23,
      sm: 23,
      md: 35,
      lg: 35,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: 4,
    marginBottom: 1,
    textAlign: "left",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
    paddingRight: 5,
  },
  Card: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: 15,
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
    padding: 25,
    marginTop: 16
  },
  Buttom: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 17,
    marginTop: 20,
  },
  Icon: { transform: "rotate(-40deg)" },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
  Grid5: { xs: 10, md: 5, xl: 5, lg: 5 },
};
